// Canonical ordering for all financial metrics.
// All table components should import from here to ensure consistent ordering.

export const occupancyOrder = [
    "Medicaid Days",
    "Medicaid HMO Days",
    "Medicaid Vent Days",
    "Hospice Days",
    "Medicare Days",
    "Medicare HMO Days",
    "Private Days",
    "Commercial Insurance Days",
    "VA Days",
    "Veterans Days",
    "Assisted Living Days - Waiver",
    "Assisted Living Days",
    "Memory Care Days",
    "Independent Living Days",
    "Total",
    "Occupancy",
    "SNF Total",
    "SNF Occupancy",
    "Skilled",
];

export const revenueOrder = [
    "Medicaid",
    "Medicaid Vent",
    "Medicaid HMO",
    "Hospice",
    "Medicare",
    "Medicare HMO",
    "HMO Rate",
    "Private",
    "Insurance",
    "Veterans",
    "Assisted Living - Waiver",
    "Assisted Living",
    "Memory Care",
    "Independent Living",
    "Net Provider Assessment",
    "Ancillary",
    "CNA/QIP Revenue",
    "PA MDOI Revenue",
    "Other Revenue",
    "Total",
    "Total SNF Revenue",
    "Total ALF Revenue",
    "Total ILF Revenue",
    "Covid Revenue",
];

export const expenseOrder = [
    "Nursing and Medical",
    "Nursing Bonuses",
    "Nursing Agency",
    "Nursing Admin",
    "AL Nursing",
    "General Nursing Expenses",
    "Therapy",
    "Part B Expense",
    "Pharmacy Expense",
    "Other Ancillaries",
    "Ancillary Expenses",
    "Respiratory Therapy",
    "Housekeeping Laundry",
    "Social Services",
    "Food and Nutrition",
    "Maintenance",
    "Recreation",
    "Payroll Taxes Benefits",
    "Utilities",
    "Real Estate Tax",
    "Property Insurance",
    "Admin Salaries",
    "Operating General and Admin",
    "Marketing",
    "Insurance Expense",
    "Assessment Tax",
    "Bad Debt",
    "Management Fees",
    "CMPs/Penalties",
    "Total",
];

export const ebitdarOrder = [
    "EBITDAR",
];

export const adjustmentsOrder = [
    "Normalize Bad Debt at 1.5%",
    "Adjust Bad Debt",
    "Normalize Mgmt Fees at 5.0%",
    "Adjust Management Fees",
    "Adjust RE Tax",
    "Adjust Real Estate Tax",
    "Adjust Assessment Tax",
    "Adjust CMPs/Penalties",
    "Adjust Total",
    "Adjusted Revenue",
    "Adjusted Expenses",
    "Total Adjustments",
    "Adjusted EBITDAR",
    "UPL",
    "Pre UPL Adjusted EBITDAR",
];

// Generic sort function that sorts items according to a given order array.
// Items not in the order array are placed at the end in their original order.
export const sortByMetricOrder = (items, order) => {
    return [...items].sort((a, b) => {
        const aType = a.Type || '';
        const bType = b.Type || '';

        const aIndex = order.findIndex(item =>
            aType.toLowerCase() === item.toLowerCase() ||
            aType.toLowerCase().includes(item.toLowerCase())
        );
        const bIndex = order.findIndex(item =>
            bType.toLowerCase() === item.toLowerCase() ||
            bType.toLowerCase().includes(item.toLowerCase())
        );

        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return 0;
    });
};
